import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAccountSession } from '../lib/accountSession';

/**
 * Public site shell.
 *
 * The navigation labels are written here rather than read from the design
 * registry: the registry mixes English and Korean ("All Games" next to "소식"),
 * and one language per surface is the rule for user-facing copy.
 */

const NAV = [
  { label: '게임', href: '/games' },
  { label: '소식', href: '/news' },
  { label: '이벤트', href: '/events' },
  { label: '고객지원', href: '/support' },
  { label: '소개', href: '/about' },
];

const FOOTER = [
  {
    title: '게임',
    links: [
      ['전체', '/games'],
      ['모바일', '/mobile'],
      ['로블록스', '/roblox'],
      ['PC', '/pc'],
      ['출시 예정', '/coming-soon'],
    ],
  },
  {
    title: '소식',
    links: [
      ['공지·패치', '/news'],
      ['이벤트', '/events'],
      ['서비스 상태', '/status'],
    ],
  },
  {
    title: '지원',
    links: [
      ['도움말', '/support'],
      ['문의 남기기', '/support/new'],
      ['내 데이터 요청', '/privacy/requests'],
    ],
  },
  {
    title: '회사',
    links: [
      ['소개', '/about'],
      ['보도·브랜드', '/press'],
      ['채용', '/careers'],
      ['연락처', '/contact'],
    ],
  },
  {
    title: '약관',
    links: [
      ['이용약관', '/legal/terms'],
      ['개인정보 처리방침', '/legal/privacy'],
      ['오픈소스 고지', '/legal/licenses'],
    ],
  },
] as const;

export function PublicShell() {
  const session = useAccountSession();
  const { pathname } = useLocation();

  return (
    <div className="public-shell">
      <header className="public-header">
        <div className="public-header__inner">
          <Link to="/" className="public-header__brand">
            <img src="/ak-mark.png" alt="" />
            <span>ASKRS Games</span>
          </Link>

          <nav className="public-nav" aria-label="주 메뉴">
            {NAV.map((item) => {
              const active = pathname === item.href || pathname.startsWith(`${item.href}/`);

              return (
                <Link key={item.href} to={item.href} aria-current={active ? 'page' : undefined}>
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div style={{ marginLeft: 'auto' }}>
            {session.state === 'signed_in'
              ? <Link className="btn" to="/account">내 계정</Link>
              : <Link className="btn" to="/account/sign-in">로그인</Link>}
          </div>
        </div>
      </header>

      <main className="public-main">
        <Outlet />
      </main>

      <footer className="public-footer">
        <div className="public-footer__inner">
          <div>
            <div className="public-footer__brand">
              <img src="/ak-mark.png" alt="" />
              <span>ASKRS Games</span>
            </div>
          </div>

          {FOOTER.map((column) => (
            <div key={column.title}>
              <h4>{column.title}</h4>
              <ul className="public-footer__links">
                {column.links.map(([label, href]) => (
                  <li key={href}><Link to={href}>{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="public-footer__legal">
          ASKRS Games · games.askrs.com · 문의 games@askrs.com
        </div>
      </footer>
    </div>
  );
}
